import React, { useState, useRef } from "react";
import { Modal } from "react-bootstrap";
import { ButtonContainer } from "../Shared/ButtonComponent";
import styled from "styled-components";
import Union from "../../Assets/Images/Union.png";
import Input from "../Modal/Input";
// import ShowAndHidePassword from "../Modal/PasswordInput";

import ProfileSex from "./ProfileSex";
import { useAuth } from "../../hooks/useAuth";
// import { useFormik } from "formik";
import { useContext } from "react";
import { UserContext } from "../../context/userContext";
import TailoringContext from "../../context/TailoringContext";

const getColor = (props) => {
  if (props.isDragAccept) {
    return "#00e676";
  }
  if (props.isDragReject) {
    return "#ff1744";
  }
  if (props.isFocused) {
    return "#2196f3";
  }
  return "#eeeeee";
};

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-width: 2px;
  border-radius: 10px;
  border-color: ${(props) => getColor(props)};
  border-style: dashed;
  background-color: #fafafa;
  margin-bottom: 20px;
  /* color: black;
  font-weight: bold;
  font-size: 1.4rem; */
  outline: none;
  transition: border 0.24s ease-in-out;
`;

const EditProfile = ({ editProfile, setEditProfile, setProfilePic }) => {
  const [images, setImages] = useState([]);
  const [preview, setPreview] = useState("");
  const [checkedSex, setCheckedSex] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [phone, setPhone] = useState(null);
  const uploadRef = useRef(null);

  const { profileData:userData } = useContext(UserContext);
  const { errorMessage } = useContext(TailoringContext);

  let email = userData?.email;
  let first_name = userData?.first_name;
  let last_name = userData?.last_name;
  let image_url = userData?.image_url;
  let phoneNumber = userData?.phone_number;

  
  

  const { handleUpdateProfile } = useAuth();

  const handleImageUplaod = (e) => {
    setImages(e.target.files[0]);
    setPreview(URL.createObjectURL(e.target.files[0]));
  };

  const formData = new FormData();
  formData.append("email", email);
  formData.append("first_name", firstName);
  formData.append("last_name", lastName);
  formData.append("sex", checkedSex);
  formData.append("image", images);
  formData.append("phone_number", phone);

 

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div className="upload_styles">
      <Modal
        dialogClassName={"ProfileModal"}
        show={editProfile}
        onHide={() => setEditProfile(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="upload_header" closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="modal-title editProfile"
          >
            <p>Edit Profile</p>
            {errorMessage ? <p className="text-danger fs-2">{errorMessage}</p> :<p>Update your details</p>}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <div className="upload_profileImg">
              <div>
                {
                  <Container>
                    <img alt="" src={preview ? preview : image_url} />
                  </Container>
                }
              </div>
              <div>
                <p>
                  <input
                    className="d-none"
                    type="file"
                    ref={uploadRef}
                    onChange={(e) => {
                      handleImageUplaod(e);
                    }}
                    name="image"
                  />
                  Drag Picture to frame or <br />
                  <button
                    type="button"
                    className="profile_btn"
                    onClick={() => uploadRef.current.click()}
                  >
                    <img alt="img" src={Union} />
                    Select Photo
                  </button>
                </p>
              </div>
            </div>
            <div className="name_input">
              <div>
                <Input
                  placeholder="First Name"
                  name="first_name"
                  defaultValue={first_name}
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </div>
              <div>
                <Input
                  placeholder="Last Name"
                  name="last_name"
                  defaultValue={last_name}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>
            </div>
            <div className="country_input">
              <div>
                <Input
                  placeholder="Phone number"
                  name="phone_number"
                  defaultValue={phoneNumber}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
              <div className="sex_input">
                <div>
                <Input
                  placeholder="Email"
                  type="eamil"
                  name="email"
                  defaultValue={email}
                />
              </div>
              </div>
            </div>
            <div className="country_input">
              <div className="sex_input">
                <ProfileSex {...{ checkedSex, setCheckedSex }} />
              </div>
            </div>
            <div className="update_btn">
              <ButtonContainer
                type="submit"
                onClick={() => {
                  handleUpdateProfile(formData).then((res) => {
                    window.location.reload()
                    setEditProfile(false);
                    localStorage.setItem("_2mseamlessTailoring_Profile", JSON.stringify(res.data.user));
                  });
                }}
              >
                {" "}
                Update
              </ButtonContainer>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default EditProfile;
